import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY, scrollToId } from "../data/site";
import { useLang } from "../context/LangContext";

export const Footer = () => {
  const { S } = useLang();
  const F = S.footer;
  const go = (e, hash) => {
    e.preventDefault();
    scrollToId(hash);
  };

  return (
    <footer data-testid="site-footer" className="bg-[#060F1F] text-slate-300 border-t border-white/5">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <span className="inline-flex items-center gap-3">
              <img src="/logo-emblem-dark.png" alt={F.logoAlt} className="h-12 w-auto" />
              <span className="flex flex-col leading-tight">
                <span className="font-display font-bold text-white text-lg tracking-tight">GPN Sàrl</span>
                <span className="font-tech text-[9px] font-semibold uppercase tracking-[0.22em] text-sky-400">
                  {COMPANY.tagline}
                </span>
              </span>
            </span>
            <p className="mt-6 text-sm leading-relaxed text-slate-400">{F.brand}</p>
          </div>

          <div>
            <h3 className="font-tech text-xs font-semibold uppercase tracking-[0.24em] text-sky-400">{F.navTitle}</h3>
            <ul className="mt-5 space-y-3">
              {S.nav.map((item) => (
                <li key={item.hash}>
                  <a
                    href={item.hash}
                    onClick={(e) => go(e, item.hash)}
                    data-testid={`footer-nav-${item.hash.slice(1)}`}
                    className="text-sm text-slate-400 hover:text-sky-400 transition-colors"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href="#devis"
                  onClick={(e) => go(e, "#devis")}
                  data-testid="footer-nav-devis"
                  className="text-sm font-semibold text-sky-400 hover:text-sky-300 transition-colors"
                >
                  {S.ctaDevis}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-tech text-xs font-semibold uppercase tracking-[0.24em] text-sky-400">{F.contactTitle}</h3>
            <ul className="mt-5 space-y-4 text-sm">
              {COMPANY.phones.map((p, i) => (
                <li key={p.href}>
                  <a href={p.href} data-testid={`footer-phone-${i + 1}`} className="inline-flex items-center gap-2.5 text-slate-300 hover:text-sky-400 transition-colors">
                    <Phone className="w-4 h-4 text-sky-500" /> {p.label}
                  </a>
                </li>
              ))}
              <li>
                <a href={`mailto:${COMPANY.email}`} data-testid="footer-email" className="inline-flex items-center gap-2.5 text-slate-300 hover:text-sky-400 transition-colors">
                  <Mail className="w-4 h-4 text-sky-500" /> {COMPANY.email}
                </a>
              </li>
              <li className="inline-flex items-start gap-2.5 text-slate-400">
                <MapPin className="w-4 h-4 text-sky-500 mt-0.5" />
                <span>
                  GPN Sàrl — {COMPANY.tagline}
                  <br />
                  {COMPANY.address}
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-tech text-xs font-semibold uppercase tracking-[0.24em] text-sky-400">{F.infoTitle}</h3>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <Link to="/mentions-legales" data-testid="footer-link-mentions" className="text-slate-400 hover:text-sky-400 transition-colors">
                  {F.legal1}
                </Link>
              </li>
              <li>
                <Link to="/politique-de-confidentialite" data-testid="footer-link-confidentialite" className="text-slate-400 hover:text-sky-400 transition-colors">
                  {F.legal2}
                </Link>
              </li>
            </ul>
            <p className="mt-8 text-xs leading-relaxed text-slate-500">{F.zoneText}</p>
          </div>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-500">{F.rights}</p>
          <p className="font-tech text-[11px] uppercase tracking-[0.2em] text-slate-600">{F.tagline}</p>
        </div>
      </div>
    </footer>
  );
};
